// Need to use the React-specific entry point to allow generating React hooks
import { baseAPI } from "./baseAPI";
import type { ISetting } from "@backend/model/setting";

const enchancedAPI = baseAPI.enhanceEndpoints({
  addTagTypes: ["settings"],
});

// Define a service using a base URL and expected endpoints
export const settingsAPI = enchancedAPI.injectEndpoints({
  endpoints: (builder) => ({
    listSettings: builder.query<
      ISetting[],
      {
        organisationId: string;
      }
    >({
      query: ({ organisationId }) => ({
        url: `organisation/${organisationId}/settings`,
      }),
      providesTags: ["settings"],
    }),
    updateSettings: builder.mutation<
      boolean,
      { settings: ISetting[]; organisationId: string }
    >({
      query: ({ settings, organisationId }) => ({
        url: `organisation/${organisationId}/settings`,
        method: "PUT",
        body: settings,
      }),
      invalidatesTags: (res) => (res ? ["settings"] : []),
    }),
  }),
});

export const { useListSettingsQuery, useUpdateSettingsMutation } = settingsAPI;
